import { createContext} from 'react';

const TareaContext = createContext();

export default TareaContext;